<template>
  <!-- <v-parallax src="https://cdnblobendpoint.azureedge.net/bezzina-static/img/hero.jpeg" height="250"> -->
  <v-parallax :src="headerImg" :height="headerHeight">
    <div class="left-bottom-gradient"></div>
    <v-layout align-end style="position: relative;z-index:1;">
      <v-flex>
        <h3 class="display-3" id="page-name">{{ headline }}</h3>
        <div><span id="slogan" class="headline">{{ slogan }}</span></div>
      </v-flex>
    </v-layout>
  </v-parallax>
</template>

<script>
export default {
  props: {
    headline: {
      required: true,
      type: String,
      default: 'Headline'
    },
    slogan: {
      required: true,
      type: String,
      default: 'Slogan'
    },
    headerImg: {
      type: String,
      default: 'https://cdnblobendpoint.azureedge.net/bezzina-static/img/default-header.png'
    },
    headerHeight: {
      type: String,
      default: '450'
    }
  }
}
</script>

<style scoped>
#page-name,
#slogan {
  /*font-family: 'Vollkorn', serif;*/
  font-family: 'Lato', sans-serif;
}
#page-name {
  font-size: 3.5vmax;
}
#slogan {
  font-size: 2vmax;
}
.left-bottom-gradient {
  z-index: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  left: -10px;
  opacity: 0.9;
  /*background-image: radial-gradient(circle farthest-corner at center, #15497E 0%, #3D93BC 100%);*/
  background-image: radial-gradient(at bottom left, rgba(0,0,0,0.8), rgba(0,0,0,0.1), rgba(255,255,255,0));
}
</style>



// WEBPACK FOOTER //
// src/components/ParallaxHeader.vue